import { LoadableAfterPaint } from '@confluence/loadable';

export const ApprovalBanner = LoadableAfterPaint({
	name: 'ApprovalBannerLoadable',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApprovalBanner" */ '../src/BannerComponent/ApprovalBanner.tsx'
			)
		).ApprovalBanner,
});
